import {Component, OnInit} from '@angular/core';
import {ClientService} from '../../../api/client/client.service';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import Sortable from 'sortablejs'
import { Title } from '@angular/platform-browser';
// import {ToasterService} from '../../toaster-service.service';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './client.html'
})

export class Client implements OnInit {
    client = [];
    i: number;
    id: string;
    image_url: string;
    TableData = [];
    name: string;
    company: string;
    description: string;
    companylink : string;
    logo: string;
    image_file: File;
    public showinputlogo: boolean = false;
    public showoriginallogo: boolean = true;

    constructor(private clientService: ClientService,
                private router: Router ,private titleService : Title) {
    }

    ngOnInit() {
        this.titleService.setTitle("Client  | Phoenix Games");
        if (localStorage.getItem('token') && localStorage.getItem('role') == 'SUPERADMIN') {
            $(function () {
                var drEvent = $('.dropify').dropify();
                drEvent.on('dropify.afterClear', function (event, element) {
                });
            });
            this.image_url = "http://localhost:5500/uploads/client_logo/";
            this.clientService.allClient()
                .then(data => {
                    this.client = data;
                });
            var el = document.getElementById('items');
            var sortable = new Sortable(el, {
                animation: 150,
                ghostClass: 'blue-background-class'
            });
        } else {
            this.router.navigate(['/']);
        }
    }

    cancelAction() {
        this.id = "";
        this.name = "";
        this.company = "";
        this.description = "";
        this.logo = "";
        this.companylink = "";
        this.image_file = null
    }

    removelogoimages() {
        this.showinputlogo = true;
        this.showoriginallogo = false;
        this.logo = null;
        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
    }


    gettingsequence() {
        var TableData = new Array();

        $('#row-table tr').each(function (row, tr) {
            TableData[row] = {
                "id": $(tr).find('td:eq(0)').text(),
                "index": row - 1
            }
        });
        TableData.shift();
        this.TableData = TableData;
        var tbdata = {
            tabledata: this.TableData
        };
        this.clientService.uClientindex(tbdata).then(data => {
            if (data.status) {
                this.clientService.allClient()
                    .then(data => {
                        this.client = data;
                    });
                // this.cancelAction();
            } else {
                // this.cancelAction();
            }
        });
    }

    detectFileslogo(event) {
        this.image_file = <File>event.target.files[0];
    }

  


    submitClient() {
        if (this.name == undefined || this.name == undefined) {
            $.notify({
                message: "Please fillup all feilds"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            // const fd = new FormData();
            if (this.image_file != undefined) {
                var is_formdata = true
                // fd.append('client_logo', this.image_file, this.image_file.name);
            } else {
                var is_formdata = false
                // $.notify({
                //     message: "Please select image"
                // }, {
                //     type: 'danger',
                //     placement: {
                //         from: 'bottom',
                //         align: 'right'
                //     },
                //     delay: 100,
                //     timer: 100
                // });
                // return;
            }
            // fd.append('name', this.name);
            // fd.append('company', this.company);
            // fd.append('description', this.description);
            var JsonObject = {
                name: this.name,
                company: this.company,
                description: this.description,
                companylink : this.companylink
            };
            // fd.append('sequenceindex', 1);
            this.clientService.iClient(JsonObject, this.image_file, is_formdata).then(data => {
                if (data.status) {
                    this.client.push(data.data);
                    this.cancelAction();
                    $.notify({
                        message: "Successfully inserted"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                    $(function () {
                        $('#addClient').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        }
    }

    showClient(client, i) {
      
        this.i = i;
        this.id = client.id;
        this.name = client.name;
        this.company = client.company;
        this.companylink = client.companylink;
        this.description = client.description;
        this.logo = client.logo;
        if (this.logo == null) {
            this.showinputlogo = true;
            this.showoriginallogo = false;
        } else {
            this.showinputlogo = false;
            this.showoriginallogo = true;
        }
        $(function () {
            var drEvent = $('.dropify').dropify();
            drEvent.on('dropify.afterClear', function (event, element) {
            });
        });
    }

    showDescription(client, i) {
        this.i = i;
        this.id = client._id;
        this.description = client.description;
    }

    deleteconfirmation(id, i) {
      
        this.i = i;
        this.id = id;
    }

    updateClient() {
        if (this.name == undefined || this.name == undefined) {
            $.notify({
                message: "Please fillup all feilds"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        else {
            // const frmData = new FormData();
            /*if (this.image_file != undefined) {
             frmData.append('client_logo', this.image_file, this.image_file.name);
             } else {
             $.notify({
             message: "Please select image"
             }, {
             type: 'danger',
             placement: {
             from: 'bottom',
             align: 'right'
             },
             delay: 100,
             timer: 100
             });
             return;
             }*/
            if (this.image_file != undefined) {
                var is_formdata = true
                // fd.append('client_logo', this.image_file, this.image_file.name);
            } else {
                var is_formdata = false
                // $.notify({
                //     message: "Please select image"
                // }, {
                //     type: 'danger',
                //     placement: {
                //         from: 'bottom',
                //         align: 'right'
                //     },
                //     delay: 100,
                //     timer: 100
                // });
                // return;
            }
            // frmData.append('name', this.name);
            // frmData.append('company', this.company);
            // frmData.append('description', this.description);
           
            var JsonObject = {
                name: this.name,
                company: this.company,
                companylink : this.companylink,
                description: this.description
            }
            this.clientService.uClient(this.id, JsonObject, this.image_file, is_formdata).then(data => {
                if (data.status) {
                    this.client[this.i] = data.data;
                    this.cancelAction();
                    $.notify({
                        message: "Successfully Updated"
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                    $(function () {
                        $('#updateClient').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
        }
    }

    deleteClient() {
        this.clientService.dClient(this.id).then(data => {
            if (data.status) {
                this.client.splice(this.i, 1);
                $.notify({
                    message: "Successfully Deleted"
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                this.cancelAction();
            }
        });
    }
}





// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/client/client.page.ts